import { keepPreviousData } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import LayoutContext from 'components/Layout/LayoutContext';
import translation from 'locales/translation';
import moment from 'moment';
import {
  Col,
  Pagination,
  Row,
  TableWithOverflow,
  ToastTypes,
} from 'plataforma-fundacao-componentes';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGetGuest } from 'services/editVotes';

type Table = {
  nome: string;
  cpfCnpj: string | null;
  tipoPresenca: string;
  dataPresenca: string;
  isAssociado: boolean;
};

const ListGuest = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);

  const params = useParams();
  const { showToast } = useContext(LayoutContext);

  const {
    data,
    refetch,
    isError: isErrorData,
    error: errorData,
    isLoading,
  } = useGetGuest((params as { id: string }).id, currentPage, pageSize, '', {
    placeholderData: keepPreviousData,
  });

  useEffect(() => {
    if (isErrorData) {
      showToast({
        pauseOnFocusLoss: true,
        theme: ToastTypes.Error,
        showStatusBar: true,
        timeout: 4000,
        label:
          translation.Toasts.Errors.Keys[
            `${
              (errorData as AxiosError<Error>).response?.data.message ||
              (errorData as AxiosError<Error>).response?.data ||
              (errorData as AxiosError<Error>).message
            }` as keyof typeof translation.Toasts.Errors.Keys
          ] ?? translation.Toasts.Errors.defaultAlternative,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isErrorData]);

  return (
    <Row>
      <Row>
        <Col>
          <TableWithOverflow
            showTopNavigator={false}
            noResultMessage={'Não há convidados para listar'}
            columns={[
              {
                key: 'name',
                props: {
                  align: 'left',
                },
                value: 'Nome',
              },
              {
                key: 'associate',
                props: {
                  align: 'left',
                },
                value: 'Associado',
              },
              {
                key: 'date',
                props: {
                  align: 'left',
                },
                value: 'Data e hora',
              },
            ]}
            lines={data!?.elements!?.map((row: Table, index: number) => {
              return {
                key: index,
                name: row.nome,
                associate: row.isAssociado ? 'Sim' : 'Não',
                date: moment(row.dataPresenca).format('DD/MM/yyyy - HH:mm:ss'),
              };
            })}
          />
        </Col>
        <Col>
          <Pagination
            totalPages={data!?.totalPages}
            currentPage={currentPage}
            onPageChange={(_, val) => {
              setCurrentPage(val);
            }}
            loading={isLoading}
            disabled={isLoading}
            rowsPerPage={{
              rows: pageSize,
              options: [10, 25, 50],
              onChange: (_, size) => {
                setPageSize(size);
                setCurrentPage(1);
                setTimeout(() => {
                  refetch();
                }, 150);
              },
            }}
            countPages={{
              rows: pageSize,
              totalItems: data!?.totalElements,
            }}
          />
        </Col>
      </Row>
    </Row>
  );
};

export default ListGuest;
